import { useTheme } from '@mui/material/styles';
import EditableNameCell from './EditableNameCell';

import {
  dateColumn,
  errorsColumn,
  idColumn,
  stateColumn,
  taskCountColumn,
  tasksColumn,
  userColumn,
} from 'pages/WorkflowRunsPage/workflowListColumns';

import useAutofetchedAccountsAsync from 'store/useAutofetchedAccountsAsync';
import useUsers from 'store/useUsers';

import IRunEntry from 'types/IRunEntry';
import IColumnDefinition from '../Table/IColumnDefinition';

export function useColumns(
  onShowErrors: (run: IRunEntry) => void,
  stateFilter?: { onStateClick?: (state: string) => void; selectedState?: string },
): IColumnDefinition<IRunEntry>[] {
  const theme = useTheme();
  const users = useUsers();
  const usersById = new Map(users.map((user) => [user.id, user]));

  const accountsAsync = useAutofetchedAccountsAsync();
  const accounts =
    (accountsAsync.status === 'SUCCESS' || accountsAsync.status === 'REFRESH' ? accountsAsync.data : null) ?? [];
  const accountsById = new Map(accounts.map((account) => [account.id, account]));

  return [
    {
      header: 'Name',
      key: 'name',
      render: (run) => <EditableNameCell run={run} />,
    },
    dateColumn(),
    idColumn(),
    userColumn(usersById, accountsById),
    stateColumn(theme, stateFilter),
    tasksColumn(stateFilter),
    taskCountColumn(),
    errorsColumn(onShowErrors),
  ];
}
